import { ArrowRight, Star } from "@phosphor-icons/react";
import { tagLabel, text } from "../i18n.js";
import { assetHref, themeHref } from "../lib/routes.js";
import type { CommunityThemeView, Locale } from "../types.js";
import { StatusBadge } from "./StatusBadge.js";

export function ThemeCard({ locale, theme }: { readonly locale: Locale; readonly theme: CommunityThemeView }) {
  const t = text(locale);
  const version = theme.versions.find((entry) => entry.version === theme.latestVersion) ?? theme.versions[0];
  if (!version) return null;
  const content = theme.localized[locale];
  return (
    <article className={`theme-card${theme.featured ? " theme-card-featured" : ""}`}>
      <a className="theme-card-media" href={themeHref(locale, theme.id)} tabIndex={-1} aria-hidden="true">
        <img
          src={assetHref(version.preview.url)}
          alt=""
          width={version.preview.width}
          height={version.preview.height}
          loading="lazy"
        />
      </a>
      <div className="theme-card-body">
        <div className="theme-card-kicker">
          {theme.featured ? <span className="featured"><Star aria-hidden="true" weight="fill" />{locale === "zh-CN" ? "精选" : "Featured"}</span> : <span />}
          <StatusBadge locale={locale} status={version.supportStatus} />
        </div>
        <h3><a href={themeHref(locale, theme.id)}>{content.name}</a></h3>
        <p>{content.summary}</p>
        <div className="tag-list" aria-label={locale === "zh-CN" ? "主题标签" : "Theme tags"}>
          {theme.tags.map((tag) => <span key={tag}>{tagLabel(locale, tag)}</span>)}
        </div>
        <dl className="theme-card-meta">
          <div><dt>{t.author}</dt><dd>@{theme.author.github}</dd></div>
          <div><dt>{t.version}</dt><dd>{version.version}</dd></div>
        </dl>
        <a className="text-link" href={themeHref(locale, theme.id)}>{t.viewDetails}<ArrowRight aria-hidden="true" weight="bold" /></a>
      </div>
    </article>
  );
}
